export const userCookies = {
  C_ID: 'c_id',
  CONTACT_UUID: 'contact_uuid',
  CURRENCY_RATE: 'currency_rate',
  NEWSLETTER_SIGNUP: 'newsletter_signup',
  CONSENT_STATUS: 'consent_status'
};

export const clientCookies = {
  PRODUCT_ANALYTICS_CLIENT_ID: 'pa_client_id',
  PRODUCT_ANALYTICS_USER_ID: 'pa_user_id'
};
